import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router';
import * as screenConfig from './../config/screenConfig';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import { Loader } from './loader';
import * as DashboardActions from './../actions/dashboard_actions';
import * as FacilitiesActions from './../actions/facilities_actions';
import _ from 'lodash';
import moment from 'moment';
import * as api_urls from './../config/api_urls';
import * as UserActions from "./../actions/user_actions";
import IdleTimer from "react-idle-timer";

let Header = React.createClass({

    getInitialState() {
        return ({
            config: screenConfig
                .getConfigbyScreenName(this.props.screenIdentifier),
            isDeleting: false,
            NotificationLengths: '', notificationsClicket: false

        });
    },
    componentDidUpdate() {



    },
    componentWillReceiveProps(nextProps) {
        // if (nextProps.Notifications) {
        //     var notificationLength = nextProps.Notifications.length;
        //     this.setState({ NotificationLengths: notificationLength })
        // }

        if (this.state.notificationsClicket) {
            if (nextProps.FacilitiesDetails.FaciliteDetailsByID ? nextProps.FacilitiesDetails.FaciliteDetailsByID.status == 200 : false) {
                this.setState({ notificationsClicket: false });
                this.props.router.push('/facilities/details');
            }
        }
    },

    componentDidMount() {

        if (this.props.LogingDetails && this.props.LogingDetails.selectedUserRoleID == 1) {
            this.props.Dispatch(DashboardActions.notifications());
        }




    },
    modelNodification() {

        this.setState({
            isDeleting: true
        });

    },
    viewAll() {
        this.setState({
            isDeleting: false
        })
        this.props.router.push('/moreNotification')
    },
    removeCancelPrompt() {
        this.setState({
            isDeleting: false
        })

    },
    openclinic(event) {

        let clinicId = event.target.dataset.clinicid;
        this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(clinicId));
        this.setState({ notificationsClicket: true, isDeleting: false });
    },
    logout(event) {
        this.props.router.push('/logout');
    },
    // handleOnAction(event) {
    //     console.log("user did something", event);
    // },

    // handleOnActive(event) {
    //     console.log("user is active", event);
    //     console.log("time remaining", this.idleTimer.getRemainingTime());
    // },

    handleOnIdle(event) {
        this.props.Dispatch(UserActions.logout(
            {
                "appType": "WEB",
                "id": this.props.LogingDetails && this.props.LogingDetails.data && this.props.LogingDetails.data.id
            }
        ));
        this.props.Dispatch(UserActions.user_log_out());
        // this.props.Dispatch(UserActions.user_log_out());
        // localStorage.clear();
        // this.props.router.push("/?timeout=1");
        // console.log("user is idle", event);
        // console.log("last active", this.idleTimer.getLastActiveTime());
    },
    render() {

        return (

            <div>
                <IdleTimer
                    ref={(ref) => {
                        this.idleTimer = ref;
                    }}
                    // timeout={1000 * 6 * 1}
                    timeout={1000 * 60 * 15}
                    onActive={this.handleOnActive}
                    onIdle={this.handleOnIdle}
                    onAction={this.handleOnAction}
                    debounce={250}
                />
                <div className="content-head">
                    <div className="row">
                        <div className="col-xs-7">
                            <h2>
                                {!this.props.breadcrumb && this.state.config.title && this.state.config.title === 'DASHBOARD' ? this.props.UserDetails.selectedClinicName : this.state.config.title}
                            </h2>
                        </div>
                        <div className="col-xs-5 pull-right">
                            <div className="name-holder">
                                {this.props.LogingDetails.loginData.data.facilities && this.props.LogingDetails.loginData.data.facilities[0].role.name !== 'Super Admin' && <img src={require('./../images/home.svg')} onClick={() => { this.props.router.push('/select-clinic') }} className='home-icon' />}
                                <div className='profile-image'>
                                    {this.props.LogingDetails && this.props.LogingDetails.userImage ? <img src={api_urls.DownloadImageURL + this.props.LogingDetails.userImage.data} /> : <img src={require('./../images/user.png')} />}
                                </div>
                                {this.props.LogingDetails.selectedUserRoleID == 1 && this.props.Notifications && this.props.Notifications.length > 0 &&
                                    <button onClick={this.modelNodification} className="badge">{this.props.Notifications.length}</button>
                                }
                                {this.props.LogingDetails.selectedUserRoleID == 1 && <span onClick={this.modelNodification} className="icon-bell"></span>}
                                <span className="name-holder-item">{this.props.LogingDetails.loginData && this.props.LogingDetails.loginData.data.userName}</span>
                                <span onClick={this.logout} className='name-holder-item cursor'>|  Logout</span>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    ref='deleteAddressModal'
                    isOpen={this.state.isDeleting}
                    className='delete-prompt modalPopup header-notifications'
                    contentLabel='modalPopup'>
                    <div className="white-box notification-text">
                        <h3> <button onClick={this.removeCancelPrompt} className="pull-right notification-close">X</button></h3>
                        {this.props.Notifications && this.props.Notifications.length ?
                            <ul >
                                <li><span className="ntf-name">Name</span><span className="ntf-role">Role</span><span className="ntf-status">Status</span><span className="ntf-time pull-right">Time</span></li>

                                {_.map(this.props.Notifications, (Data, key) => {
                                    if (key < 3) {

                                        let d = new Date(Data.deactivateRequestDate);
                                        let time = moment([d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getMilliseconds()]).fromNow();
                                        return (
                                            <li key={key} data-clinicID={Data.facility.id} onClick={this.openclinic}><span data-clinicID={Data.facility.id} className="ntf-name">{Data.firstName} {Data.lastName}</span><span data-clinicID={Data.facility.id} className="ntf-role">{Data.role}</span><span data-clinicID={Data.facility.id} className="ntf-status">{Data.status}</span><span data-clinicID={Data.facility.id} className="pull-right">{time}</span></li>
                                        )
                                    }

                                })
                                }

                            </ul>
                            : <ul><li>No notifications to display.</li></ul>
                        }
                        <h3> {this.props.Notifications && this.props.Notifications.length ? <span className="gray-button" onClick={this.viewAll}>VIEW ALL </span> : ""}</h3>
                    </div>
                </Modal>

                { this.props.loader && <div className="inheader"><Loader /></div>}
            </div >


        );
    }
});

let mapStateToProps = (state) => {


    return {
        LogingDetails: state.User,
        Dashboard: state.Dashboard,
        Notifications: state.Dashboard.Notifications,
        FacilitiesDetails: state.Facilites,
        UserDetails: state.User,

    };
};
let mapDispatchToProps = (dispatch) => ({
    DashboardActions: bindActionCreators(DashboardActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));



/** WEBPACK FOOTER **
 ** ./src/components/header.js
 **/